import React from "react"
import axios from "axios"
import { ToastContainer } from "react-toastify"
import "modern-normalize/modern-normalize.css"
import "./src/css/variables.css"
import "./src/css/styles.css"
import "react-toastify/dist/ReactToastify.css"
import "photoswipe/dist/photoswipe.css"

axios.defaults.baseURL = process.env.GATSBY_API_URL
axios.defaults.withCredentials = true

// get CSRF Cookie
// this is mainly used for form submissions
axios.get("/sanctum/csrf-cookie")

export const wrapRootElement = ({ element }) => (
  <>
    {element}
    <ToastContainer />
  </>
)
